/* eslint-disable max-len */
export default {
    tooltip: 'Aby pobrać ebook, wypełnij formularz.',
    form: {
        title: 'Wypełnij formularz, aby pobrać e-booka',
        placeholder: {
            name: 'Imię',
            surname: 'Nazwisko',
            email: 'Twój email firmowy',
            company: 'Firma'
        },
        label: {
            checkbox: 'Dane administrowane są przez Sagiton Sp. z o.o., zostały przekazane dobrowolnie i będą przetwarzane przez administratora zgodnie z przepisami ustawy z dnia 29 sierpnia 1997r. o ochronie danych osobowych (Dz. U. z 2002r. nr 101, poz. 926 z późn. zm.) w celach marketingowych, sprzedaży produktów i usług Sagiton Sp.z o.o. Zostałem/am poinformowany/a o prawie dostępu do treści swoich danych, ich poprawiania oraz prawie wniesienia w każdym czasie sprzeciwu wobec ich przetwarzania.',
            checkbox2: 'Wyrażam zgodę na otrzymywanie od Sagiton Sp.z o.o. informacji handlowej za pomocą poczty elektronicznej.',
            button: 'Pobierz e-book za darmo',
            refresh: 'Odśwież'
        }
    },
    footer: {
        title: 'Interesuje Cię kompleksowe rozwiązanie,<br/> związane z bezpieczeństwem gromadzonych przez Ciebie danych?',
        button: 'Sprawdź naszą ofertę'
    },
    download: {
        text: 'Dziękujemy za wypełnienie formularza. Link pozwalający na pobranie ebooka wysłaliśmy na podany email.'
    },
    list: [{
        id: 'gdpr_all_about',
        slug: 'wszystko-o-rodo',
        header: {
            title: 'Pobierz darmowy ebook',
            subtitle: 'Wszystko co musisz wiedzieć na temat RODO',
            cover: {
                image: 'wszystko-o-rodo-cover-pl.jpg',
                alt: 'Pobierz darmowy ebook - Wszystko co musisz wiedzieć na temat RODO/GDPR'
            }
        },
        content: {
            title: 'Z naszego przewodnika dowiesz się:',
            list: [
                'Czy RODO/GDPR dotyczy Ciebie lub Twojej firmy?',
                'Jakie dane będą pod ochroną i czy istnieją rodzaje danych, których przetwarzanie będzie zakazane?',
                'Jakie kary, związane z niewłaściwym przetwarzaniem danych, mogą spotkać Twoją Firmę?',
                'I najważniejsze, jak w przypadku ewentualnej kontroli udowodnić, że dobrze zabezpieczasz dane.'
            ]
        }
    },
    {
        id: 'gdpr_for_marketing',
        slug: 'rodo-w-marketingu',
        header: {
            title: 'Pobierz darmowy poradnik',
            subtitle: 'Marketing zgodny z RODO',
            cover: {
                image: 'rodo-w-marketingu-cover-pl.png',
                alt: 'Pobierz darmowy poradnik - Marketing zgodny z RODO/GDPR'
            }
        },
        content: {
            title: 'Z naszego przewodnika dowiesz się:',
            list: [
                'Jak przeprowadzać proces profilowania zgodnie z RODO/GDPR?',
                'Jak powinna wyglądać zgoda na przetwarzanie danych osobowych?',
                'W jaki sposób dział marketingu może chronić informacje?',
                'A także poznasz pięć zasad współpracy między działem marketingu a bezpieczeństwa'
            ]
        }
    },
    {
        id: 'views_on_cybersecurity',
        slug: 'podejscia-do-cyberbezpieczenstwa',
        header: {
            title: 'Poradnik ekspercki',
            subtitle: 'Trzy podejścia do cyberbezpieczeństwa',
            cover: {
                image: 'podejscia-do-cyberbezpieczenstwa-cover-pl.png',
                alt: 'Pobierz darmowy poradnik - Trzy podejścia do cyberbezpieczeństwa'
            }
        },
        content: {
            title: 'Z naszego e-booka dowiesz się:',
            list: [
                'jakie dane w firmie powinny być zabezpieczane,',
                'jak działają cyberprzestępcy i kto może paść ich ofiarą,',
                'na ile organizacje są świadome swoich słabości i konieczności dostosowania się do przepisów RODO,',
                'czym jest systemowe podejście do bezpieczeństwa.'
            ]
        }
    }]
};



// WEBPACK FOOTER //
// ./src/i18n/pl/ebook.js